import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "Pagination" })
export default class Pagination extends Vue {
    public localizer: any = Localizer;
    public footerPages: any[] = [];
    public paginatorCount: number = 0;
    public paginatorIndex: number = 0;

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly pageIndex: number;
    @Prop() readonly pageCount: number;

    public created() {
        this.paginatorCount = Math.ceil(this.pageCount / 4);
        this.paginatorIndex = Math.trunc((this.pageIndex - 1) / 4);

        this.footerPages = [...Array(this.pageCount).keys()].slice(this.paginatorIndex * 4, (this.paginatorIndex + 1) * 4);
    }

    public async setSearch(index: number) {
        const url = new URL(window.location.href);
        url.searchParams.set("page", (index).toString());
        window.location.href = url.toString();
    }

    public async goToPage(index: number) {
        this.setSearch(index);
    }

    public async goToPrevPage() {
        if (this.pageIndex < 2) {
            return;
        }
        this.setSearch((this.pageIndex - 1));
    }

    public async goToNextPage() {
        if (this.pageIndex >= this.pageCount) {
            return;
        }

        this.setSearch((this.pageIndex + 1));
    }

    public goToPageSelector(type: string) {
        if (type === "plus") {
            this.goToPage(this.footerPages.slice(-1)[0] + 2);
        }

        if (type === "less") {
            this.goToPage(this.footerPages.slice(0)[0]);
        }
    }
}